import { motion } from "framer-motion";

/**
 * Latency animation — an orb pulsing packets outward from the center.
 * Uses SVG + Framer Motion. Decorative — sits behind hero copy on Home.
 */
export default function LatencyPulse({ className = "" }) {
  return (
    <div className={`relative ${className}`}>
      <svg viewBox="0 0 400 400" className="w-full h-full">
        <defs>
          <radialGradient id="core" cx="50%" cy="50%" r="50%">
            <stop offset="0%"  stopColor="#EC4899" stopOpacity="1" />
            <stop offset="70%" stopColor="#7C3AED" stopOpacity="0.5" />
            <stop offset="100%"stopColor="#7C3AED" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="ring" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%"  stopColor="#7C3AED" />
            <stop offset="100%"stopColor="#EC4899" />
          </linearGradient>
        </defs>

        {/* Concentric static rings */}
        {[60, 100, 150, 200].map((r) => (
          <circle key={r} cx="200" cy="200" r={r} fill="none"
            stroke="rgba(124, 58, 237, 0.18)" strokeDasharray="2 6" strokeWidth="1" />
        ))}

        {/* Animated expanding pulses */}
        {[0, 0.9, 1.8].map((delay, i) => (
          <motion.circle
            key={i}
            cx="200" cy="200" r="50"
            fill="none"
            stroke="url(#ring)"
            strokeWidth="1.5"
            initial={{ r: 40, opacity: 0.9 }}
            animate={{ r: 200, opacity: 0 }}
            transition={{ duration: 2.6, delay, repeat: Infinity, ease: "easeOut" }}
          />
        ))}

        {/* Core */}
        <circle cx="200" cy="200" r="80" fill="url(#core)" />
        <motion.circle
          cx="200" cy="200" r="20"
          fill="white"
          animate={{ scale: [1, 1.15, 1] }}
          transition={{ duration: 2.4, repeat: Infinity }}
        />

        {/* Orbiting node */}
        <motion.g animate={{ rotate: 360 }} transition={{ duration: 12, repeat: Infinity, ease: "linear" }} style={{ transformOrigin: "200px 200px" }}>
          <circle cx="200" cy="60" r="4" fill="#EC4899" />
        </motion.g>
        <motion.g animate={{ rotate: -360 }} transition={{ duration: 18, repeat: Infinity, ease: "linear" }} style={{ transformOrigin: "200px 200px" }}>
          <circle cx="200" cy="20" r="3" fill="#7C3AED" />
        </motion.g>
      </svg>
    </div>
  );
}
